import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Stack, Tab, Tabs, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useCompany } from "../../contexts/CompanyContext";
import ShipmentNotifications from "../../organisms/Imports/ShipmentNotifications";
import CrudCatalogue from "../../organisms/Catalogues/CrudCatalogue";
import ShipmentEmbarquesTab from "../../organisms/Imports/ShipmentEmbarquesTab";

export default function ShipmentScreen() {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label={`Embarques ${selectedCompany.name}`} />
          <Tab label="Catálogos" />
          <Tab label="Notificaciones" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <ShipmentEmbarquesTab companyId={selectedCompany.id} />
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ maxWidth: '800px', margin: '0 auto', mt: 5 }}>
          <Stack spacing={2}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Navieras / Aerolineas</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="FOREIGN_TRANSPORT" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Forwarders</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="FORWARDER" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Tipos de Envío</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="SHIPMENT_TRANSPORT_TYPE" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Forwarders Terrestres</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="FORWARDER_LAND" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Agentes Aduanales</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="CUSTOMS_AGENT" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Tipos de Embarque</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="SHIPMENT_TYPE" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Modos de Embarque</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="SHIPMENT_MODE" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Puertos de Llegada</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="PORT_DESTINATION" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Puertos de Origen</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="PORT_OF_ORIGIN" />
              </AccordionDetails>
            </Accordion>
          </Stack>
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={2}>
        <ShipmentNotifications companyId={selectedCompany.id} />
      </LGTabPanel>
    </DashboardLayout>
  );
}
